import fetchHandler, { fetchHandlerForm } from './Handler';

// import { Category } from '../../types/cards';

export const addProduct = async (body: FormData): Promise<any> => {
	// console.log(body, '------------->');
	try {
		const response = await fetchHandlerForm({
			method: 'POST',
			endpoint: 'admin/product',
			body,
		});
		console.log(response, '---------> addProduct fintion api');
		if (response) {
			return response;
		} else if (response.isError) {
			return response;
		}
	} catch (error) {
		console.error('errror showing', error);
		throw error;
	}
};

export const getAllProducts = async (): Promise<any> => {
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: 'admin/product', // Replace with your actual API endpoint
		});
		return response;
	} catch (error) {
		console.error('Error fetching blogs:', error);
		throw new Error('Could not fetch blogs. Please try again later.');
	}
};
export const approvalProducts = async (): Promise<any> => {
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: 'admin/product/vendor/all', // Replace with your actual API endpoint
		});
		return response;
	} catch (error) {
		console.error('Error fetching blogs:', error);
		throw new Error('Could not fetch blogs. Please try again later.');
	}
};

export const deleteProduct = async (data: any): Promise<any> => {
	try {
		const response = await fetchHandler({
			method: 'DELETE',
			endpoint: `admin/product/${data}`,
		});
		if (response) {
			return await getAllProducts();
		}
		return response;
	} catch (error) {
		console.error('Error fetching chatbots:', error);
		throw new Error('Could not fetch chatbots. Please try again later.');
	}
};

// =======================================================
export const updateProduct = async (body: FormData, id: string): Promise<any> => {
	try {
		const response = await fetchHandlerForm({
			method: 'PATCH',
			endpoint: `admin/product/${id}`,
			body,
		});
		return response;
	} catch (error) {
		console.error('Error fetching chatbots:', error);
		throw new Error('Could not fetch chatbots. Please try again later.');
	}
};
export const getSinlgeProduct = async (id?: string): Promise<any> => {
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: `admin/product/${id}`,
		});
		return response;
	} catch (error) {
		console.error('Error fetching chatbots:', error);
		throw new Error('Could not fetch chatbots. Please try again later.');
	}
};

export const updateCategoryStatus = async (data: any, id: string): Promise<any> => {
	try {
		const response = await fetchHandlerForm({
			method: 'PATCH',
			endpoint: `category/${id}`,
			body: data,
		});
		return response;
	} catch (error) {
		console.error('Error fetching chatbots:', error);
		throw new Error('Could not fetch chatbots. Please try again later.');
	}
};

export const getSingleCategory = async (id: string): Promise<any> => {
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: `category/${id}`,
		});
		return response;
	} catch (error) {
		console.error('Error fetching chatbots:', error);
		throw new Error('Could not fetch chatbots. Please try again later.');
	}
};
export const getAllProductsEnquiries = async (): Promise<any> => {
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: 'admin/inquiry', // Replace with your actual API endpoint
		});
		return response;
	} catch (error) {
		console.error('Error fetching blogs:', error);
		throw new Error('Could not fetch blogs. Please try again later.');
	}
};

export const updateProductEnquiry = async (data: any, id: string): Promise<any> => {
	try {
		const response = await fetchHandler({
			method: 'PATCH',
			endpoint: `admin/inquiry/${id}`,
			data,
		});
		return response;
	} catch (error) {
		console.error('Error fetching chatbots:', error);
		throw new Error('Could not fetch chatbots. Please try again later.');
	}
};

export const deleteProductImage = async (id: string, data: any): Promise<any> => {
	try {
		const response = await fetchHandler({
			method: 'DELETE',
			endpoint: `admin/product/${id}/image`,
			data,
		});
		if (response.success) {
			return await getAllProducts();
		} else if (response.isError) {
			return response;
		}
	} catch (error) {
		throw new Error('Could not fetch chatbots. Please try again later.');
	}
};

export const deleteColorVariantImage = async (
	productId: string,
	variantId: string,
	imageId: string,
	imageIndex: number
): Promise<any> => {
	try {
		const response = await fetchHandler({
			method: 'DELETE',
			endpoint: `admin/product/${productId}/${variantId}/${imageId}/${imageIndex}/image`,
		});
		if (response) {
			return await getAllProducts();
		}
		return response;
	} catch (error) {
		console.error('Error fetching chatbots:', error);
		throw new Error('Could not fetch chatbots. Please try again later.');
	}
};
